<template>
  <v-card v-if="properties != null" flat>
    <CImage
      v-if="properties.image != null"
      :url="properties.image"
      :alt="properties.title"
      size="100px"
    ></CImage>
    <div class="centered pt-4" v-if="properties.title != null">
      <PrimaryTitle
        :title="properties.title"
        :variant_color="variant_color"
      ></PrimaryTitle>
    </div>
    <div class="centered" style="padding-top:20px">
      <span
        v-if="properties.subtitle"
        class="subsection-subtitle medium_grey--text"
        >{{ properties.subtitle }}</span
      >
    </div>
    <div v-if="properties.children" class="grid-content">
      <v-row
        v-if="properties.children.length > 0"
        justify="center"
        class="grid"
      >
        <v-col
          v-for="(elem, i) in properties.children"
          :key="i"
          cols="12"
          md="4"
          class="grid-content-item"
          :class="
            elem.type == 'simple-image' ? ' max_simple_image_grid_item' : ''
          "
        >
          <FactoryComponent
            :component="elem"
            :image_contained="true"
            :variant_color="variant_color"
          />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped></style>

<script>
import PrimaryTitle from "../SubComponents/PrimaryTitle";
import CImage from "../SubComponents/Image";

export default {
  name: "Grid",
  components: { PrimaryTitle, CImage },
  props: {
    properties: {
      type: Object,
      default: null
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.grid {
  width: 100%;
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.grid-content {
  margin: 0px 0px 0px 0px;
  padding-top: 10px;
}

.max_simple_image_grid_item {
  max-height: 180px;
}
</style>
